export const setFormikError = (formik, err) => {
  if (err?.message || err?.detail) {
    formik.setStatus(err?.message || err?.detail);
  } else if (err?.details || err?.errors) {
    formik.setErrors(err?.errors);
  } else if (!err?.message) {
    formik.setErrors(err);
  } else {
    formik.setStatus(err.message);
  }
};

export const parseRechargeSdkErrorMessage = (error) => {
  if (error.name !== 'RechargeRequestError' || !error.message) {
    return {};
  }

  let parsedError = {};
  try {
    parsedError = JSON.parse(error.message);
  } catch (e) {}

  return parsedError;
};
